"use strict";

var _classCallCheck = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var rxjs_1 = require("rxjs");

var operators_1 = require("rxjs/operators");

var WebSocketProvider = /*#__PURE__*/function () {
  function WebSocketProvider(endpoint) {
    var _this = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, WebSocketProvider);

    this.endpoint = endpoint;
    this.connected$ = new rxjs_1.BehaviorSubject(null);
    this.notification$ = new rxjs_1.BehaviorSubject(null);
    this.state$ = new rxjs_1.BehaviorSubject(null);
    this.error$ = new rxjs_1.BehaviorSubject(null);
    this.pendingRequests = [];
    this.request$ = new rxjs_1.BehaviorSubject(null);
    this.response$ = new rxjs_1.BehaviorSubject(null);
    this.reconnectTimeout = null;
    this.webSocketConstructor = WebSocketProvider.detectWebSocketConstructor(options.webSocketConstructor);
    this.options = Object.assign(Object.assign({
      connect: false,
      reconnectTime: WebSocketProvider.DEFAULT_RECONNECT_TIME,
      requestTimeout: WebSocketProvider.DEFAULT_REQUEST_TIMEOUT
    }, options), {
      webSocketConstructor: null
    });
    this.state$.pipe(operators_1.map(function (state) {
      return state === WebSocketProvider.States.Connected;
    }), operators_1.filter(function (value) {
      return value !== _this.connected$.getValue();
    })).subscribe(this.connected$);
    this.state$.pipe(operators_1.filter(function (state) {
      return state === WebSocketProvider.States.Connected;
    }), operators_1.mergeMap(function () {
      return rxjs_1.from(_this.pendingRequests.slice(0, _this.pendingRequests.length));
    })).subscribe(this.request$);
    this.request$.pipe(operators_1.filter(function (request) {
      return !!request;
    }), operators_1.tap(function (request) {
      _this.connection.send(JSON.stringify(request));
    })).subscribe();
    this.messageHandler = this.messageHandler.bind(this);
    this.closeHandler = this.closeHandler.bind(this);
    this.errorHandler = this.errorHandler.bind(this);

    if (this.options.connect) {
      this.connect();
    }
  }

  _createClass(WebSocketProvider, [{
    key: "send",
    value: function send(request, callback) {
      if (!this.state) {
        this.connect();
      }

      if (this.connected) {
        this.request$.next(request);
      } else {
        this.pendingRequests.push(request);
      }

      var requestTimeout = this.options.requestTimeout;
      var id = request.id;
      this.response$.pipe(operators_1.filter(function (response) {
        return response && id === response.id;
      }), operators_1.take(1), operators_1.timeoutWith(requestTimeout, rxjs_1.throwError(new Error('request timeout ...')))).subscribe({
        error: function error(err) {
          return callback(err);
        },
        next: function next(response) {
          return callback(null, response);
        }
      });
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        switch (_this2.state) {
          case WebSocketProvider.States.Connected:
            _this2.removeHandlers();

            try {
              _this2.connection.close();

              _this2.state$.next(WebSocketProvider.States.Disconnected);

              resolve();
            } catch (err) {
              reject(err);
            }

            break;

          case WebSocketProvider.States.Disconnected:
            _this2.cancelReconnect();

            _this2.removeHandlers();

            resolve();
            break;

          case WebSocketProvider.States.Connecting:
            _this2.state$.next(WebSocketProvider.States.Disconnecting);

            break;
        }
      });
    }
  }, {
    key: "connect",
    value: function connect() {
      var _this3 = this;

      this.state$.next(WebSocketProvider.States.Connecting);
      var removeConnectHandlers;

      var openHandler = function openHandler() {
        return removeConnectHandlers();
      };

      var errorHandler = function errorHandler(err) {
        return removeConnectHandlers(err);
      };

      removeConnectHandlers = function removeConnectHandlers(err) {
        _this3.connection.removeEventListener('open', openHandler);

        _this3.connection.removeEventListener('error', errorHandler);

        switch (_this3.state) {
          case WebSocketProvider.States.Connecting:
            if (err) {
              _this3.state$.next(WebSocketProvider.States.Disconnected);

              _this3.reconnect();
            } else {
              _this3.state$.next(WebSocketProvider.States.Connected);

              _this3.addHandlers();
            }

            break;

          case WebSocketProvider.States.Disconnecting:
            // force close
            try {
              _this3.connection.close();
            } catch (err) {//
            }

            break;
        }
      };

      this.connection = new this.webSocketConstructor(this.endpoint);
      this.connection.addEventListener('open', openHandler);
      this.connection.addEventListener('error', errorHandler);
    }
  }, {
    key: "reconnect",
    value: function reconnect() {
      var _this4 = this;

      var reconnectTime = this.options.reconnectTime;
      this.reconnectTimeout = setTimeout(function () {
        _this4.reconnectTimeout = null;

        _this4.connect();
      }, reconnectTime);
    }
  }, {
    key: "cancelReconnect",
    value: function cancelReconnect() {
      if (this.reconnectTimeout) {
        clearTimeout(this.reconnectTimeout);
        this.reconnectTimeout = null;
      }
    }
  }, {
    key: "addHandlers",
    value: function addHandlers() {
      this.connection.addEventListener('message', this.messageHandler);
      this.connection.addEventListener('close', this.closeHandler);
      this.connection.addEventListener('error', this.errorHandler);
    }
  }, {
    key: "removeHandlers",
    value: function removeHandlers() {
      this.connection.removeEventListener('message', this.messageHandler);
      this.connection.removeEventListener('close', this.closeHandler);
      this.connection.removeEventListener('error', this.errorHandler);
    }
  }, {
    key: "messageHandler",
    value: function messageHandler(_ref) {
      var data = _ref.data;

      try {
        var parsed = JSON.parse(data);
        var id = parsed.id;

        if (id) {
          this.response$.next(parsed);
        } else {
          var method = parsed.method,
              params = parsed.params;

          if (method === 'eth_subscription') {
            this.notification$.next(params);
          }
        }
      } catch (err) {
        this.error$.next(err);
      }
    }
  }, {
    key: "closeHandler",
    value: function closeHandler() {
      this.removeHandlers();
      this.state$.next(WebSocketProvider.States.Disconnected);
      this.reconnect();
    }
  }, {
    key: "errorHandler",
    value: function errorHandler(err) {
      this.error$.next(err);

      try {
        this.connection.close();
      } catch (err) {
        this.error$.next(err);
      }
    }
  }, {
    key: "connected",
    get: function get() {
      return this.state === WebSocketProvider.States.Connected;
    }
  }, {
    key: "state",
    get: function get() {
      return this.state$.getValue();
    }
  }, {
    key: "error",
    get: function get() {
      return this.error$.getValue();
    }
  }], [{
    key: "detectWebSocketConstructor",
    value: function detectWebSocketConstructor() {
      var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var result;

      if (option) {
        result = option;
      } else {
        result = typeof WebSocket !== 'undefined' ? WebSocket : null;
      }

      if (!result) {
        throw new Error('please setup options.webSocketConstructor');
      }

      return result;
    }
  }]);

  return WebSocketProvider;
}();

exports.WebSocketProvider = WebSocketProvider;
WebSocketProvider.DEFAULT_RECONNECT_TIME = 5000;
WebSocketProvider.DEFAULT_REQUEST_TIMEOUT = 3000;

(function (WebSocketProvider) {
  var States;

  (function (States) {
    States["Connecting"] = "Connecting";
    States["Connected"] = "Connected";
    States["Disconnecting"] = "Disconnecting";
    States["Disconnected"] = "Disconnected";
  })(States = WebSocketProvider.States || (WebSocketProvider.States = {}));
})(WebSocketProvider = exports.WebSocketProvider || (exports.WebSocketProvider = {}));